import type { Waveform } from '~/models/studio';

export interface ComputedConstraints {
  duration: number;
  maxVal: number;
  area: number;
}

// Per-object weak map is great here, because we reuse waveform objects aggressively, until modified.
// There is no similar-waveforms deduplication for simplicity. Automatic cleanup is also desired.
export const constraintCache: WeakMap<Waveform, ComputedConstraints> =
  new WeakMap();
